import * as React from "react"

type Props = {
  children: React.ReactNode
  fontSize?: string
  lgFontSize?: string
  textCenter?: boolean
  fontAvenir?: boolean
  classes?: string
}

const Heading: React.FC<Props> = ({
  children,
  fontSize = "base",
  lgFontSize = "",
  textCenter = false,
  fontAvenir = false,
  classes = "",
}) => (
  <h1
    className={
      "font-bold text-gray-800" +
      " " +
      [
        `text-${fontSize}`,
        ...(lgFontSize ? [`lg:text-${lgFontSize}`] : []),
        ...(fontAvenir ? ["font-avenir"] : ["font-hiragino"]),
        ...(textCenter ? ["text-center"] : []),
      ].join(" ") +
      " " +
      classes
    }
  >
    {children}
  </h1>
)

export default Heading
